<template>
  <div class="head-banner-breadcrumb wc-lg">
    <div class="bg-overlay"></div>
    <div class="head-banner-breadcrumb__img_wrapper">
      <div class="bg-overlay"></div>
      <picture>
        <source
          media="(max-width: 767px)"
          :srcset="_.get(content.images[0], 'devices.mobile')"
        />
        <source
          media="(max-width: 1023px)"
          :srcset="_.get(content.images[0], 'devices.tablet')"
        />
        <img
          :src="_.get(content.images[0], 'devices.desktop')"
          :alt="
            $route.name == 'PageViewRouter_ge'
              ? content.seo_keywords_ge
              : content.seo_keywords_en
          "
          class="cover"
        />
      </picture>
    </div>
    <div class="head-banner-breadcrumb__inner container">
      <Breadcrumb />

      <div class="head-banner-breadcrumb__text-box flex column">
        <h1 class="f-38 bold f-white uppercase">
          {{ _.get(content, "title") }}
        </h1>
        <p class="f-14 regular f-white">{{ _.get(content, "teaser") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./BreadCrumb.vue";
import resize_handler from "@/mixins/resize_handler";
export default {
  components: {
    Breadcrumb
  },
  props: ["contentData"],
  mixins: [resize_handler],
  computed: {
    content() {
      return _.get(this.contentData, "data.list[0]");
    }
  }
};
</script>

<style></style>
